<script>
export default {
  name: 'FirebaseUserView',
  data: () => ({
    uid: '',
    isLoading: false,
  }),
  methods: {
    async search() {
      try {
        this.isLoading = true
        const user = await this.$api.firebaseUsers(this.uid).get()
        this.$router.push({ path: `/firebase_user/${user.uid}` })
      } catch (err) {
        console.error(err)
        this.$toast.error(this.$t('firebaseUser.message.userNotFound'))
      }
      this.isLoading = false
    },
  },
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>{{ $t('firebaseUser.text.title') }}</h1>
        <v-text-field
          v-model="uid"
          :label="$t('firebaseUser.text.firebaseUid')"
          outlined
        />
        <v-btn :loading="isLoading" @click="search">{{
          $t('common.button.search')
        }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
